module.exports = __webpack_public_path__ + "static/papa_reserve.f6caa0f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/papa_reserve.png
// module id = 501
// module chunks = 35783957827783